const setActiveCategory = (category) => {
    return {
        type: 'SET_ACTIVE_CATEGORY',
        payload: category[0].toUpperCase() + category.slice(1).toLowerCase()
    };
};

const updateSummaryCategory = (update) => {
    return {
        type: 'UPDATE_SUMMARY_STATE',
        payload: update
    };
};
// eslint-disable-next-line
export default {
    setActiveCategory,
    updateSummaryCategory
};
